var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('Clock',{attrs:{"state":_vm.flag}})],1),_c('b-col',[_c('Tally',{on:{"test":_vm.next}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }